const translateType = (type) => {
  const translations = {
    preventive: "Preventiva",
    corrective: "Corretiva",
    misuse: "Mau Uso",
  };
  return translations[type.toLowerCase()] || type;
};

const MaintenanceReport = ({
  waitingTicket,
  data_time,
  mechanic,
  type_of_review,
  name,
  whatsapp,
  model,
  licensePlate,
  chassi,
  type_of_event,
  color,
  maintenanceItems,
  totalPreventivePrice,
  totalCorrectivePrice,
  totalMisusePrice,
  cobrancaTotal,
  observations,
}) => {
  return (
    <>
      <style>{`
        body {
          font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
          font-size: 10pt;
          color: #333;
          background-color: #fff; /* Garante fundo branco */
        }
        .report-container {
          padding: 25px;
          background-color: #fff; /* Garante fundo branco */
        }
        .header-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding-bottom: 15px;
          border-bottom: 2px solid #333;
        }
        .header-logo img {
          width: 120px;
          height: auto;
        }
        .header-ticket h2 {
          margin: 0;
          font-size: 22pt;
          font-weight: bold;
          color: #e44131;
        }
        .header-ticket p {
          margin: 0;
          font-size: 9pt;
          text-align: right;
        }
        .header-bottom {
          text-align: center;
          padding: 10px 0;
        }
        .header-bottom h1 {
          margin: 0 0 5px 0;
          font-size: 12pt;
        }
        .header-bottom p {
          margin: 2px 0;
          font-size: 9pt;
          color: #555;
        }
        .section-title {
          font-size: 14pt;
          font-weight: bold;
          border-bottom: 1px solid #ccc;
          padding-bottom: 5px;
          margin-top: 25px;
          margin-bottom: 10px;
        }
          
        .info-table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 20px;
        }
        .info-table td {
          padding: 4px 0;
          vertical-align: top;
        }
        .info-table td:nth-child(odd) { /* Estilo para os rótulos */
          font-weight: bold;
          width: 110px;
        }
        .items-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 15px;
        }
        .items-table th, .items-table td {
          border: 1px solid #ddd;
          padding: 8px;
          text-align: left;
        }
        .items-table th {
          background-color: #f2f2f2;
          font-weight: bold;
          -webkit-print-color-adjust: exact;
        }
        .items-table tr:nth-child(even) {
          background-color: #f9f9f9;
          -webkit-print-color-adjust: exact;
        }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .totals-section {
          display: flex;
          justify-content: flex-end;
          margin-top: 20px;
        }
        .vihicle-info {
          font-weight: bold;
        }
        .totals-table {
          width: 350px;
          border-collapse: collapse;
        }
        .totals-table td {
          padding: 8px;
          border-bottom: 1px solid #eee;
        }
        .totals-table tr.final-total td {
          font-size: 12pt;
          font-weight: bold;
          background-color: #e44131;
          color: white;
          -webkit-print-color-adjust: exact;
        }
        .footer-section {
          margin-top: 40px;
        }
        .signature-line {
          border-top: 1px solid #333;
          width: 300px;
          margin: 60px auto 10px auto;
          text-align: center;
        }
      `}</style>

      <div className="report-container">
        {/* CABEÇALHO - NOVA ESTRUTURA */}
        <div className="header-top">
          <div className="header-logo">
            <img
              src="data:image/png;base64,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"
              alt=""
            />
          </div>
          <div className="header-bottom">
            <h1>LOCAVIBE LOCACOES LTDA</h1>
            <p>
              Av. São Paulo, Quadra 19, Lote 03, N° 1651 - Jardim das
              Esmeraldas, Goiânia - GO
            </p>
            <p>
              CNPJ: 48.012.048/0001-46 | (62) 3003-6199 | locavibe10@gmail.com
            </p>
          </div>
          <div className="header-ticket">
            <h2>Senha #{waitingTicket}</h2>
            <p>{data_time}</p>
          </div>
        </div>

        {/* INFORMAÇÕES DO CLIENTE E VEÍCULO */}
        <div className="section-title">Informações Gerais</div>
        <table className="info-table vihicle-info">
          <tbody>
            <tr>
              <td style={{ width: "60%" }}>Associado: {name}</td>
              <td>Chassi: {chassi}</td>
            </tr>
            <tr>
              <td>Telefone: {whatsapp}</td>
              <td>Tipo de Evento: {type_of_event}</td>
            </tr>
            <tr>
              <td>Veículo: {model}</td>
              <td>Placa: {licensePlate}</td>
            </tr>
            <tr>
              <td>Tipo de Ordem: {type_of_review}</td>
              <td>Cor: {color}</td>
            </tr>
          </tbody>
        </table>

        {/* RESTANTE DO CÓDIGO (sem alterações) */}
        <div className="section-title">Peças e Serviços</div>
        <table className="items-table">
          <thead>
            <tr>
              <th className="text-center" style={{ width: "10%" }}>
                Nº
              </th>
              <th>Descrição</th>
              <th className="text-center" style={{ width: "10%" }}>
                Qtd.
              </th>
              <th style={{ width: "20%" }}>Tipo</th>
              <th className="text-right" style={{ width: "15%" }}>
                Valor (R$)
              </th>
            </tr>
          </thead>
          <tbody>
            {maintenanceItems.map((item, index) => (
              <tr key={index}>
                <td className="text-center">{item.sequencial_number}</td>
                <td>{item.name}</td>
                <td className="text-center">{item.quantity}</td>
                <td>{translateType(item.type)}</td>
                <td className="text-right">{item.sellPrice.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="totals-section">
          <table className="totals-table">
            <tbody>
              <tr>
                <td>Total Preventivo:</td>
                <td className="text-right">R$ {totalPreventivePrice}</td>
              </tr>
              <tr>
                <td>Total Corretivo:</td>
                <td className="text-right">R$ {totalCorrectivePrice}</td>
              </tr>
              <tr>
                <td>Total Mau Uso:</td>
                <td className="text-right">R$ {totalMisusePrice}</td>
              </tr>
              <tr className="final-total">
                <td>Valor a Cobrar:</td>
                <td className="text-right">R$ {cobrancaTotal.toFixed(2)}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="footer-section">
          <div className="section-title">Observações</div>
          {observations?.length > 0 ? (
            observations.map((item, index) => <p key={index}>- {item.text}</p>)
          ) : (
            <p>Nenhuma observação.</p>
          )}

          <div className="signature-line">
            <p>Assinatura do Mecânico Responsável</p>
            <p>
              <strong>Mecânico:</strong> {mechanic}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default MaintenanceReport;
